import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ReportActionCreators, IQuestDetailReportResponse } from '@nkr/store/index';
import { IFamilyVoucherScreeningTransactionDetails, IPreWorkUpTransactionDetails } from '@nkr/models/index';
import { QuestCategory } from '@nkr/enums/index';
import { HeaderWrapper, NavItemWrapper, NavWrapper } from './styles';
import { Button, Col, FormControl, Nav, Row, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import { IQuestTransactionRequest } from '@nkr/models/quest-transaction-request';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { downloadFile } from '@nkr/services/download-file';
import QuestReportGrid from './quest-trans-detail-grid';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    // reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getQuestReport: (startDate: string, endDate: string, filterDate: number) => Promise<IQuestDetailReportResponse>,
    getQuestExport: (startDate: string, endDate: string, filterDate: number, reportId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    startDate: string,
    endDate: string,
    filterDate: number,
    centerId: number,
    activeTab: QuestCategory,
    report: {
        preWorkupLabResults: IPreWorkUpTransactionDetails[],
        fvScreeningResults: IFamilyVoucherScreeningTransactionDetails[],
    },
    filteredList: IQuestTransactionRequest[];
}

class QuestTransactionReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        startDate: '',
        endDate: '',
        filterDate: 0,
        centerId: 0,
        activeTab: 0,
        report: null,
        filteredList: []
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (event: GridReadyEvent) => {
        this.gridApi = event.api;
        this.gridColumnApi = event.columnApi;

        this.gridApi.sizeColumnsToFit();
    }

    componentDidMount = () => {
        //get dates
        let startDate = '';
        let endDate = '';
        let filterDate = 0;

        if (startDate == '' || endDate == '') {
            startDate = moment().startOf('month').format('YYYY-MM-DD');
            endDate = moment().endOf('month').format('YYYY-MM-DD');
            filterDate = 0;
        } else {
            startDate = this.state.startDate;
            endDate = this.state.endDate;
            filterDate = this.state.filterDate;
        }

        this.getData(startDate, endDate, filterDate);
    }

    getData = (startDate: string, endDate: string, filterDate: number) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getQuestReport(startDate, endDate, filterDate)
                .then((response: IQuestDetailReportResponse) => {

                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    }, () => {
                        this.handleTabChange(QuestCategory.PreWorkUp);
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    dateRangeSearch = () => {
        this.getData(this.state.startDate, this.state.endDate, this.state.filterDate);
    }

    onGridSizeChanged = () => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = this.gridColumnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        this.gridColumnApi.setColumnsVisible(columnsToShow, true);
        this.gridColumnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        this.gridApi.sizeColumnsToFit();
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }


    handleToggleButtonFieldChange = (field: string, value: number) => {
        
            this.setState({
                filterDate: value
            });
   
    }


    handleExportVrl = (reportId: number) => {
        let sDate = this.state.startDate;
        let eDate = this.state.endDate;
        let filterDate = this.state.filterDate;
        let filenName = '';

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getQuestExport(sDate, eDate, filterDate, reportId).then((response: any) => {
                switch (reportId) {
                    case 1:
                        filenName = 'family-voucher-screening-tests';
                        break;
                    case 2:
                        filenName = 'pre-workup-labs';
                        break;
                }

                downloadFile(response.data, `quest-transactions-` + filenName + `.csv`, 'text/csv');

                this.props.hideLoading();
            });
        });

    }

    handleTabChange = (selectedTab: number) => {
        let categoryList = [];
        let reportList = _.cloneDeep(this.state.report);

        switch (selectedTab) {
            case QuestCategory.PreWorkUp:
                categoryList = reportList.preWorkupLabResults;
                break;

            case QuestCategory.FamilyVoucherScreening:
                categoryList = reportList.fvScreeningResults;
                break;

            default:
                break
        }

        this.setState({
            filteredList: categoryList,
            activeTab: selectedTab
        });
    }

    csvExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'quest-transactions-detail.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        if (this.state.report == null)
            return null;

        const totalPreWorkUp = this.state.report.preWorkupLabResults.length;
        const totalFamilyVoucherScreening = this.state.report.fvScreeningResults.length;
        const tabWidth = '230';

        return (
            <>
                <HeaderWrapper className='container-fluid'>
                    <div className='billing-header' style={{ marginBottom: 0 }}>
                        Quest Transactions Report
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='startDate'
                                        value={this.state.startDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                                <div style={{ marginRight: 5 }}>End Date:</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='endDate'
                                        value={this.state.endDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>


                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 70 }}>
                                <div style={{ marginRight: 5 }}>Filter on Date?:</div>
                                <div>
                                    <ToggleButtonGroup type='radio' name='filterDate' value={this.state.filterDate}>
                                        <ToggleButton value={0} className={this.state.filterDate == 0 ? 'btn-primary btn-md' : 'btn-default btn-md'} onClick={() => this.handleToggleButtonFieldChange('filterDate', 0)}>Completed &nbsp;</ToggleButton>
                                        <ToggleButton value={1} className={this.state.filterDate == 1 ? 'btn-primary btn-md' : 'btn-default btn-md'} onClick={() => this.handleToggleButtonFieldChange('filterDate', 1)}>Requested &nbsp;</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>


                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <Button bsStyle={'primary'} onClick={this.dateRangeSearch}>Search</Button>
                            </div>
                        </div>

                        <div style={{ display: 'flex' }}>
                            <Well style={{ fontSize: 14, padding: 10 }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col xs={12} lg={2} style={{ width: 200 }}>Pre WorkUp Labs: <strong>{totalPreWorkUp}</strong></Col>
                                    <Col xs={12} lg={3}>
                                        <Button bsStyle="warning" bsSize="xsmall" onClick={() => this.handleExportVrl(2)}>Export CSV</Button>
                                    </Col>
                                </Row>

                                <Row style={{ marginBottom: 0 }}>
                                    <Col xs={12} lg={2} style={{ width: 200 }}>FV Screenings: <strong>{totalFamilyVoucherScreening}</strong></Col>
                                    <Col xs={12} lg={3}>
                                        <Button bsStyle="warning" bsSize="xsmall" onClick={() => this.handleExportVrl(1)}>Export CSV</Button>
                                    </Col>
                                </Row>
                            </Well>
                        </div>
                    </div>
                </HeaderWrapper>

                <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                    <div style={{ paddingLeft: 15, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Nav bsStyle='tabs' className='acc-tabs' onSelect={(e: any) => this.handleTabChange(e)}>
                            <NavItemWrapper eventKey={QuestCategory.PreWorkUp} active={this.state.activeTab == QuestCategory.PreWorkUp} tabWidth={tabWidth}>
                                Pre Workup Labs <b>({totalPreWorkUp})</b>
                            </NavItemWrapper>

                            <NavItemWrapper eventKey={QuestCategory.FamilyVoucherScreening} active={this.state.activeTab == QuestCategory.FamilyVoucherScreening} tabWidth={tabWidth}>
                                Family Voucher Screenings <b>({totalFamilyVoucherScreening})</b>
                            </NavItemWrapper>

                        </Nav>
                    </div>
                </NavWrapper>

                <QuestReportGrid
                    data={this.state.report}
                    selectedTab={this.state.activeTab}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        // reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getQuestReport: (startDate, endDate, filterDate) => {
            return dispatch(ReportActionCreators.getQuestReport(startDate, endDate, filterDate));
        },
        getQuestExport: (invoiceYear, invoiceMonth, filterDate, reportId) => {
            return dispatch(ReportActionCreators.getQuestExport(invoiceYear, invoiceMonth, filterDate, reportId));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(QuestTransactionReport);